/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MessProject } from '../models/MessProject';
import type { OBRSessionStatus } from '../models/OBRSessionStatus';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class StateService {
    /**
     * Get Active Reflectometers
     * Get all active reflectometers from OBR session status
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getActiveReflectometers(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/state/reflectometers',
        });
    }
    /**
     * Get Last Structure By Project
     * @param projectId
     * @returns MessProject Successful Response
     * @throws ApiError
     */
    public static getLastMessproject(
        projectId: string,
    ): CancelablePromise<MessProject> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/state/last-structure/{project_id}',
            path: {
                'project_id': projectId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Save Last Session Messproject
     * Save the last session messproject id to redis rest api with the key "last_session:{user_id}" for the user session.
     * @param messprojectId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static postLastSession(
        messprojectId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/state/last-session',
            query: {
                'messproject_id': messprojectId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Last Session Messproject
     * Get the last session messproject id from redis rest api with the key "last_session:{user_id}" for the user session.
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getLastSession(): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/state/last-session',
        });
    }
    /**
     * Get Active Reflectometers State
     * Get  OBR session status as set by the OBR.
     * @param reflectometerId
     * @returns OBRSessionStatus Successful Response
     * @throws ApiError
     */
    public static getReflectometerStatus(
        reflectometerId: string,
    ): CancelablePromise<OBRSessionStatus> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/state/reflectometer/{reflectometer_id}',
            path: {
                'reflectometer_id': reflectometerId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get User State
     * @param userId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getUserState(
        userId: string,
    ): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/state/user-state/{user_id}',
            path: {
                'user_id': userId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Save User State
     * @param userId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static saveUserState(
        userId: string,
        requestBody: Record<string, any>,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/state/user-state/{user_id}',
            path: {
                'user_id': userId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
